import styled from "styled-components";
import { theme } from "@themes";

export const StyleContainerArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  grid-gap: 0.5em;
  padding: 0 10px;
  div {
    box-shadow: none;
  }
`;

export const BackButton = styled.span`
  font-family: ${({ theme }) => theme.font.tertiary}, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.neutral.gray[3000]};
  margin-left: 10px;
`;

export const ArrowBackDiv = styled.div`
  width: 50%;
  padding-bottom: 1px;
  cursor: pointer;
  svg {
    color: ${({ theme }) => theme.primary.purple};
  }
`;
